import * as Models from ".";

export interface IPartnerModel {
  code: string;
  name: string;
  type: string;
  logoPath: string;
  userIds: Array<string>;
  groupIds: Array<string>;
  partnerSettings: Models.PartnerSettingsModel.IPartnerSettings;
}

export class PartnerModel implements IPartnerModel {
  code: string;
  name: string;
  type: string;
  logoPath: string;
  userIds: Array<string> = [];
  groupIds: Array<string> = [];
  partnerSettings: Models.PartnerSettingsModel.IPartnerSettings;

  constructor(name: string, code: string) {
    this.name = name;
    this.code = code;
  }
}
